import { Link } from 'react-router-dom';
import type { CSSProperties } from 'react';

export default function HeroSection() {
  return (
    <section className="hb">
      <div className="hbg a" aria-hidden="true">
        <i className="bl b1" />
        <i className="bl b2" />
        <i className="bl b3" />
        <i className="dg" />
        <i className="sp" style={{ left: "18%", top: "22%" }} />
        <i className="sp" style={{ left: "82%", top: "14%", animationDelay: "-1.5s" }} />
        <i className="sp" style={{ left: "88%", top: "46%", animationDelay: "-3s" }} />
        <i className="sp" style={{ left: "8%", top: "52%", animationDelay: "-2.2s" }} />
      </div>
      <div className="hbg u" aria-hidden="true">
        <i className="bl b1" />
        <i className="bl b2" />
        <i className="bl b3" />
        <i className="dg" />
        <i className="sp" style={{ left: "16%", top: "20%" }} />
        <i className="sp" style={{ left: "82%", top: "14%", animationDelay: "-1.5s" }} />
        <i className="sp" style={{ left: "88%", top: "46%", animationDelay: "-3s" }} />
        <i className="sp" style={{ left: "8%", top: "52%", animationDelay: "-2.2s" }} />
      </div>
      <div className="wrap">
        <div>
          <span className="pill rv">
            <img src="/site/logos/ax-symbol.svg" alt="" />
            업무용 AI Agent 플랫폼
          </span>
          <h1 className="rv d1">
            우리 회사 데이터로
            <br />
            우리만의
            {' '}
            <span style={{ color: "var(--ac)" }}>AI Agent</span>
            를
            <br />
            만들어보세요.
          </h1>
          <p className="rv d2">
            파일·웹·DB 연결부터 AI Agent 제작·배포까지,
            <br />
            개발 부담을 줄여주는 업무용 AI 플랫폼
          </p>
          <div className="cta rv d3">
            <Link className="btn p" to="/contact">무료 체험</Link>
            <Link className="btn o" to="/product">기능 자세히보기</Link>
          </div>
        </div>
        <div className="hsw hsw2 rv d2">
          <div className="htabs">
            <button className="on" data-h="a">
              <b>
                <span className="dt" style={{ background: "var(--ac)" }} />
                관리자 포탈
              </b>
              <span>우리 조직에 맞는 AI를 만드는 곳</span>
              <i />
            </button>
            <button data-h="u">
              <b>
                <span className="dt" style={{ background: "var(--teal)" }} />
                사용자 포탈
              </b>
              <span>업무에 필요한 답을, 바로</span>
              <i />
            </button>
          </div>
          <div className="hpan on" data-h="a" data-dur="6500">
            <div className="iso">
              <div className="board">
                <div className="tile fx" style={{ left: "20px", top: "20px", "--tc": "#E1E4EC" } as CSSProperties}>
                  <i>
                    <img src="/site/logos/slack.svg" alt="" />
                  </i>
                </div>
                <div className="tile fx" style={{ left: "200px", top: "0", "--tc": "#B3CCFA", background: "linear-gradient(145deg,#60A5FA,#2563EB)" } as CSSProperties}>
                  <i>
                    <svg className="i">
                      <use href="#doc" />
                    </svg>
                  </i>
                </div>
                <div className="tile fx" style={{ left: "380px", top: "30px", "--tc": "#E1E4EC" } as CSSProperties}>
                  <i>
                    <img src="/site/logos/google-drive.svg" alt="" />
                  </i>
                </div>
                <div className="tile fx" style={{ left: "10px", top: "200px", "--tc": "#FCD9A0", background: "linear-gradient(145deg,#FBBF24,#EA8A0C)" } as CSSProperties}>
                  <i>
                    <svg className="i">
                      <use href="#clock" />
                    </svg>
                  </i>
                </div>
                <div className="tile fx" style={{ left: "190px", top: "180px", width: "150px", height: "150px", "--tc": "#A9A3F0", background: "linear-gradient(145deg,#8B84F0,#635BD8)" } as CSSProperties}>
                  <i style={{ background: "none", boxShadow: "none", width: "auto" }}>
                    <img src="/site/logos/ax-symbol-white.svg" alt="" style={{ width: "76px", height: "auto" }} />
                  </i>
                </div>
                <div className="tile fx" style={{ left: "390px", top: "210px", "--tc": "#F9B5D5", background: "linear-gradient(145deg,#F472B6,#DB2777)" } as CSSProperties}>
                  <i>
                    <svg className="i">
                      <use href="#spark" />
                    </svg>
                  </i>
                </div>
                <div className="tile fx" style={{ left: "40px", top: "380px", "--tc": "#E1E4EC" } as CSSProperties}>
                  <i>
                    <img src="/site/logos/notion.svg" alt="" />
                  </i>
                </div>
                <div className="tile fx" style={{ left: "220px", top: "390px", "--tc": "#9FE3B5", background: "linear-gradient(145deg,#4ADE80,#16A34A)" } as CSSProperties}>
                  <i>
                    <svg className="i">
                      <use href="#msg" />
                    </svg>
                  </i>
                </div>
                <div className="tile fx" style={{ left: "400px", top: "390px", "--tc": "#E1E4EC" } as CSSProperties}>
                  <i>
                    <img src="/site/logos/gmail.svg" alt="" />
                  </i>
                </div>
              </div>
              <div className="fl toast" style={{ right: "24px", top: "24px" }}>
                <i>
                  <svg className="i">
                    <use href="#check" />
                  </svg>
                </i>
                AI Agent 배포 완료
              </div>
              <div className="fl ui chat grad">
                <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px", fontWeight: "700", color: "var(--ac)" }}>
                  <span className="ico" style={{ background: "var(--ac)", width: "24px", height: "24px", borderRadius: "7px" }}>
                    <svg className="i" style={{ width: "12px", height: "12px" }}>
                      <use href="#msg" />
                    </svg>
                  </span>
                  관리자 포탈 · AI Agent 테스트 및 배포
                </div>
                <div className="bub">휴가 신청 절차를 알려주세요.</div>
                <div className="ans">
                  사내 규정에서 필요한 내용을 찾아 안내합니다.
                  <span className="srcc">
                    <svg className="i">
                      <use href="#doc" />
                    </svg>
                    출처 · 사내 업무 매뉴얼
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="hpan" data-h="u" data-dur="6500">
            <div className="upv">
              <div className="uw">
                <div className="ul">
                  <div className="nb">
                    <svg className="i">
                      <use href="#plus" />
                    </svg>
                    새 대화
                  </div>
                  <small>사용 가능한 챗봇 · 4</small>
                  <div className="ub2 on">
                    <span className="bi">규</span>
                    <div>
                      <b>사내 규정 안내</b>
                      <small>회사 공식</small>
                    </div>
                  </div>
                  <div className="ub2">
                    <span className="bi">매</span>
                    <div>
                      <b>업무 매뉴얼 검색</b>
                      <small>회사 공식</small>
                    </div>
                  </div>
                  <div className="ub2">
                    <span className="bi">영</span>
                    <div>
                      <b>영업 데이터 조회</b>
                      <small>회사 공식</small>
                    </div>
                  </div>
                  <div className="ub2">
                    <span className="bi">고</span>
                    <div>
                      <b>고객 문의 응대</b>
                      <small>회사 공식</small>
                    </div>
                  </div>
                  <small className="urch">최근 대화</small>
                  <div className="urc">
                    <span>연차 사용 기준 문의</span>
                    <span>출장비 정산 방법</span>
                    <span>보안 교육 일정</span>
                  </div>
                </div>
                <div className="uc">
                  <div className="uch">
                    <span className="bi" style={{ background: "var(--teal)", color: "#fff" }}>규</span>
                    <div>
                      <b>사내 규정 안내</b>
                      <small>
                        <span className="dt" style={{ background: "var(--grn)" }} />
                        배포됨 · Bedrock · Sonnet 4
                      </small>
                    </div>
                  </div>
                  <div className="ucb">
                    <div className="q">휴가 신청 절차를 알려주세요.</div>
                    <div className="typing">
                      <i />
                      <i />
                      <i />
                    </div>
                    <div className="a">
                      <span className="bi" style={{ background: "var(--tll)", color: "#0E8C95" }}>
                        <svg className="i">
                          <use href="#spark" />
                        </svg>
                      </span>
                      <div className="ab">
                        <b>업무에 필요한 답을, 바로</b>
                        <p>사내 규정에서 필요한 내용을 찾아 안내합니다.</p>
                        <ol className="uans">
                          <li>
                            <i>1</i>
                            그룹웨어에서 근태 신청 메뉴를 선택합니다.
                          </li>
                          <li>
                            <i>2</i>
                            휴가 종류와 기간, 사유를 입력합니다.
                          </li>
                          <li>
                            <i>3</i>
                            팀장 승인 후 휴가가 확정됩니다.
                          </li>
                        </ol>
                        <div className="usrc">
                          <span className="srcc">
                            <svg className="i">
                              <use href="#doc" />
                            </svg>
                            출처 · 사내 업무 매뉴얼
                          </span>
                          <span className="srcc">
                            <svg className="i">
                              <use href="#doc" />
                            </svg>
                            출처 · 근태 관리 규정
                          </span>
                        </div>
                        <div className="ufq">
                          <span>연차 잔여일 확인</span>
                          <span>반차 신청 방법</span>
                          <span>휴가 취소 절차</span>
                        </div>
                        <div className="usk">
                          <small>관련 규정 요약</small>
                          <div className="sk" style={{ width: "94%" }} />
                          <div className="sk" style={{ width: "86%" }} />
                          <div className="sk" style={{ width: "90%" }} />
                          <div className="sk" style={{ width: "58%" }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="uin">
                    <span>메시지를 입력하세요...</span>
                    <i>
                      <svg className="i">
                        <use href="#up" />
                      </svg>
                    </i>
                  </div>
                </div>
              </div>
              <div className="fl ui ukpi" style={{ left: "20px", bottom: "20px", width: "176px" }}>
                <div className="kpi">
                  <small>
                    <span className="dt" style={{ background: "var(--teal)" }} />
                    사용 가능한 챗봇
                  </small>
                  <b>
                    4
                    <em>개</em>
                  </b>
                  <div className="pr">
                    <i style={{ width: "100%", background: "var(--teal)" }} />
                  </div>
                </div>
              </div>
              <div className="fl toast" style={{ right: "22px", top: "22px", boxShadow: "0 0 0 2px #A5E8EC,0 12px 28px rgba(34,191,202,.18)" }}>
                <i style={{ background: "var(--teal)" }}>
                  <svg className="i">
                    <use href="#doc" />
                  </svg>
                </i>
                출처 문서 확인
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
